import * as React from 'react';
import {IControlError, IControlSchema, ValidationResult} from "../../../Controls";
import { Component, I18NString } from "../../../Utils";
import { IDispatcher } from "../../extensions/Dispatcher";
import DateTime from '../../extensions/Datetime';
import { isUndefined, isNull, isEmpty } from 'lodash';
import Field from '../../Field';
import Alert from '../Alert';

import 'moment/locale/ru';

const momnet = require('moment');

export interface IRangeCalendarValue {
    beginDate: string;
    finishDate: string;
}

export interface IRangeCalendarSchema extends IControlSchema {
    beginDate: I18NString;
    finishDate: I18NString;
    description: I18NString;
    value?: IRangeCalendarValue;
    disabled?: boolean;
    currentDate: string;
    isMore?: boolean;
    isLess?: boolean;
}

interface ICalendarProps {
    schema: IRangeCalendarSchema;
    dispatcher?: IDispatcher;
    error: IControlError | undefined;
    visited: boolean;
}

interface State {
    isOpen: boolean,
    beginVisited: boolean,
    endVisited: boolean
}

const getTomorrow = (date: string) => {
    let tomorrow = new Date(momnet(date, 'DD.MM.YYYY HH.mm.ss').toISOString());
    tomorrow.setDate(tomorrow.getDate());
    return `${tomorrow.toJSON().slice(0, 10)}T00:00:00.000Z`;
}

const getCurrent = (date: string) => {
    let tomorrow = new Date(momnet(date, 'DD.MM.YYYY HH.mm.ss').toISOString());
    tomorrow.setDate(tomorrow.getDate() + 1);
    return `${tomorrow.toJSON().slice(0, 10)}T00:00:00.000Z`;
}

class RangeCalendar extends Component<ICalendarProps, State>{
    state = {
        isOpen: false,
        beginVisited: false,
        endVisited: false,
    };

    onClick = () => this.setState({ isOpen: !this.state.isOpen })

    onChange(date: string, name: string) {
        const { dispatcher } = this.props;
        let value = this.props.schema.value ? {...this.props.schema.value} : { beginDate: '', finishDate: '' };

        switch (name) {
            case 'begin': {
                value.beginDate = date;
                this.setState({beginVisited: true}, () => this.setVisitedIfNeeded());
                break;
            }
            case 'finish': {
                value.finishDate = date;
                this.setState({endVisited: true}, () => this.setVisitedIfNeeded());
                break;
            }
        }
        const validationResult = this.validationResult(value);
        dispatcher.onBlur(this.props.schema.id, value, !validationResult, validationResult);
    }

    setVisitedIfNeeded() {
        if(this.state.beginVisited && this.state.endVisited) {
            this.props.dispatcher.onVisit(this.props.schema.id);
        }
    }

    validationResult(value: IRangeCalendarValue): ValidationResult {
        if (value && !isEmpty(value.beginDate) && !isEmpty(value.finishDate) &&
            new Date(value.beginDate) > new Date(value.finishDate)) {
            return {message: "Дата начала должна быть меньше даты конца"};
        }

        return undefined;
    }

    componentDidMount() {
        const { schema: {value}, error } = this.props;
        if(!isEmpty(value) && !isEmpty(value.beginDate) && !isEmpty(value.finishDate)) {
            this.props.dispatcher.onVisit(this.props.schema.id);
        }

        if(error) {
            return;
        }
        const validationResult = this.validationResult(value);
        this.props.dispatcher.setError(this.props.schema.id, value, validationResult, false);
    }

    onFocus() {
    }

    onBlur(name: string) {
        switch (name) {
            case 'begin': {
                this.setState({beginVisited: true}, () => this.setVisitedIfNeeded());
                break;
            }
            case 'finish': {
                this.setState({endVisited: true}, () => this.setVisitedIfNeeded());
                break;
            }
        }
    }

    render() {
        const { schema: {disabled, isMore, isLess, description}, error, visited } = this.props;
        const value = this.props.schema.value || { beginDate: '', finishDate: ''};
        const errorMessage = visited && error && error.message;
        const currentDate = new Date(momnet(this.props.schema.currentDate, 'DD.MM.YYYY HH.mm.ss').toISOString());
        const minDate = new Date();
        minDate.setFullYear(currentDate.getFullYear() - 2);

        let status = 'default';

        if (errorMessage)
            status = "error";
        else if (!isEmpty(value.beginDate) && !isEmpty(value.finishDate))
            status = "success";
        return (
            <Field {...this.props.schema} status={status}>
                <div className="input-group-cr">
                    <DateTime disabled={disabled}
                        label={this.tr(this.props.schema.beginDate)}
                        value={value.beginDate}
                        maxDate={!isNull(isLess) && isLess ? getTomorrow(this.props.schema.currentDate) : undefined}
                        minDate={!isNull(isMore) && isMore ? getCurrent(this.props.schema.currentDate) : minDate.toString()}
                        onFocus={() => this.onFocus()}
                        onBlur={() => this.onBlur('begin')}
                        onChangeValue={(value: string) => this.onChange(value, 'begin')} />
                    <DateTime disabled={disabled}
                        value={value.finishDate}
                        maxDate={!isNull(isLess) && isLess ? getTomorrow(this.props.schema.currentDate) : undefined}
                        minDate={!isNull(isMore) && isMore ? getCurrent(this.props.schema.currentDate) : minDate.toString()}
                        onFocus={() => this.onFocus()}
                        onBlur={() => this.onBlur('finish')}
                        label={this.tr(this.props.schema.finishDate)}
                        onChangeValue={(value: string) => this.onChange(value, 'finish')} />
                    {
                        (description) && (
                            <span onClick={this.onClick} className="btn btn-default btn-circle">
                                <span className="glyphicon glyphicon-question-sign"></span>
                            </span>
                        )
                    }
                </div>
                {description && this.state.isOpen &&
                    (<div className="alert alert-warning" role="alert">{this.tr(description)}</div>)}
                {errorMessage && <Alert>{errorMessage}</Alert>}

            </Field>
        )
    }
}

export default RangeCalendar;


